module.exports = __webpack_public_path__ + "static/media/06- MONITORING EWER - SEPTEMBER 2023 _ FWB _ EN.docx.aacfb886.pdf";